module.exports = __webpack_public_path__ + "assets/img/jianjiang.47396644.png";